import React from 'react';
import AppIcon from '../common/AppIcon';
import { motion } from 'framer-motion';

const DailyTasksCard = ({ dailyTasks }) => {
  // Check if today matches the stored date, otherwise assume everything is false.
  const today = new Date().toLocaleDateString('en-CA');
  const isToday = dailyTasks && dailyTasks.date === today;

  const tasks = [
    {
      id: 'completeLesson',
      title: 'Complete a Lesson',
      completed: isToday && dailyTasks.completeLesson,
      icon: '📚'
    },
    {
      id: 'playGame',
      title: 'Play a Game',
      completed: isToday && dailyTasks.playGame,
      icon: '🎮'
    },
    {
      id: 'reviewLesson',
      title: 'Review a Lesson',
      completed: isToday && dailyTasks.reviewLesson,
      icon: '🔄'
    }
  ];

  const pointsAwarded = isToday && dailyTasks.pointsAwarded;
  const allCompleted = tasks.every(t => t.completed);

  return (
    <motion.div
      initial={{ x: 50, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.5 }}
      className="bg-white bg-opacity-20 backdrop-blur-lg rounded-2xl p-6 text-gray-800"
    >
      <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center justify-between">
        <div>
          <AppIcon name="check-square" className="mr-2 text-green-500" />
          Daily Tasks
        </div>
        {pointsAwarded && (
          <span className="text-sm bg-yellow-400 text-yellow-900 px-3 py-1 rounded-full font-bold shadow-sm">
            Bonus Awarded! +10 <AppIcon name="coins" />
          </span>
        )}
      </h2>
      
      <div className="space-y-4 mt-2">
        {tasks.map(task => (
          <div key={task.id} className="flex justify-between items-center bg-white/40 p-3 rounded-xl shadow-sm border border-white/50">
            <div className="flex items-center space-x-3">
              <span className="text-2xl">{task.icon}</span>
              <span className={`font-semibold ${task.completed ? 'text-gray-500 line-through' : 'text-gray-800'}`}>
                {task.title}
              </span>
            </div>
            <div>
              {task.completed ? (
                <div className="bg-green-500 text-white w-8 h-8 rounded-full flex items-center justify-center shadow-md">
                  <AppIcon name="check" />
                </div>
              ) : (
                <div className="bg-gray-200 text-gray-400 w-8 h-8 rounded-full flex items-center justify-center border-2 border-white/50 shadow-inner">
                  <AppIcon name="times" />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      
      {!allCompleted ? (
        <div className="mt-6 text-center text-sm font-semibold text-gray-700 bg-white/30 rounded-lg p-3">
          Complete all 3 tasks to get a <span className="text-yellow-600">10-point bonus</span>!
        </div>
      ) : (
        <div className="mt-6 text-center text-sm font-bold text-green-700 bg-green-100/60 rounded-lg p-3 shadow-inner">
          Awesome! You completed all tasks for today.
        </div>
      )}
    </motion.div>
  );
};

export default DailyTasksCard;
